module.exports = "<span><strong *ngIf=\"field\">{{field}}:</strong> <a *ngIf=\"value\" [routerLink]=\"['/admin', className, value._id]\">{{value[displayKey] || value}}</a></span>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-single-rel/display-single-rel.component.html
// module id = 293
// module chunks = 0 1